<template>
  <a-popover
    v-model:open="visible"
    placement="bottomRight"
    trigger="click"
    :arrow="false"
    destroyTooltipOnHide
  >
    <template #content>
      <div class="p-[10px_4px_0] w-[321px]">
        <div class="flex-between">
          <span class="text-16 font-semibold flex-center text-font-1">
            <Resource :src="Arrow" class="w-[20px] h-[20px] mr-[8px]" />
            {{ $t('gen-sui-suo-ding') }}
          </span>
          <CloseOutlined class="cursor-pointer text-font-50" @click="hide" />
        </div>
        <div
          v-if="
            userInfo?.identify_info?.status !== USER_VERIFY_STATUS.SUCCESS &&
            isChinese()
          "
          class="mt-[10px]"
        >
          {{
            $t(
              'tong-yi-qi-ye-zhu-ti-de-tuan-dui-zhang-hao-ke-yi-jin-hang-gen-sui-suo-ding-dang-qian-tuan-dui-mei-you-wan-cheng-qi-ye-shou-quan-ren-zheng-dian-ji'
            )
          }}
          <NuxtLink :to="{ name: PageKey.ACCOUNT_VERIFY }">
            {{ $t('qu-ren-zheng') }}
          </NuxtLink>
          。
        </div>
        <div v-else>
          <p class="text-12 text-font-60">
            *{{
              $t(
                'xuan-ze-gen-sui-suo-ding-yi-ge-tuan-dui-hou-wu-fa-shan-chu-zhong-ming-ming-qi-ta-tuan-dui-de-nei-rong-jie-chu-gen-sui-hou-hui-fu-gen-sui-qian-de-nei-rong'
              )
            }}
          </p>
          <div class="flex-between text-purple-5 text-12 font-semibold">
            <span>{{ $t('chao-ji-guan-li-yuan') }}</span>
            <span>{{ $t('tuan-dui-chuang-jian-shi-jian') }}</span>
          </div>
          <a-divider style="margin: 8px 0 18px" />
          <a-radio-group
            v-model:value="checks"
            class="w-full max-h-[180px] overflow-y-auto -mr-[10px] pr-[10px]"
          >
            <div
              v-for="x in data"
              :key="x.organization_id"
              class="flex-between mb-[12px]"
            >
              <a-radio :value="x.organization_id">
                <span class="text-font-1">{{ x.organization_name }}</span>
              </a-radio>
              <span class="text-14 text-font-80">
                {{ timeFormat(x.create_time, 'YYYY/MM/DD') }}
              </span>
            </div>
          </a-radio-group>
          <a-divider style="margin: 10px 0" />
          <div class="flex justify-end gap-x-[12px]">
            <a-button type="primary" ghost @click="hide">
              {{ $t('qu-xiao') }}
            </a-button>
            <a-button
              type="primary"
              :disabled="checks === undefined"
              @click="handleSave"
            >
              {{ $t('shen-qing-gen-sui') }}
            </a-button>
          </div>
        </div>
      </div>
    </template>
    <a-button type="primary" ghost>
      {{ $t('gen-sui-suo-ding') }}
      <a-tooltip
        placement="bottomRight"
        color="var(--back-bg)"
        destroyTooltipOnHide
      >
        <template #title>
          <span class="text-font-1">
            {{
              $t(
                'xuan-ze-gen-sui-suo-ding-yi-ge-tuan-dui-hou-wu-fa-shan-chu-zhong-ming-ming-qi-ta-tuan-dui-de-nei-rong-jie-chu-gen-sui-hou-hui-fu-gen-sui-qian-de-nei-rong'
              )
            }}
          </span>
        </template>
        <ExclamationCircleOutlined />
      </a-tooltip>
    </a-button>
  </a-popover>
</template>

<script lang="ts" setup>
import { getFollwTeam, sendFollow } from '~/api'
import type { FollowTeam } from '~/api/interface'
import { USER_VERIFY_STATUS } from '~/constants'
import Arrow from '@/assets/svg/follow.svg?url'
import { useTime } from '~/hooks/useTime'
import { PageKey } from '~/constants/page'
const { timeFormat } = useTime()

const checks = ref()
const visible = ref<boolean>(false)
const emit = defineEmits(['success'])
const userInfo = useUserInfo()

const data = ref<FollowTeam[]>([])

const hide = () => {
  visible.value = false
  checks.value = undefined
}

const { $t } = useNuxtApp()

const handleSave = async () => {
  const item = data.value.find((x) => x.organization_id === checks.value)
  if (!item) {
    return
  }

  trackEvent(TRACK_EVENT.FOLLOW_BRAND, {
    follow: item.organization_id,
  })
  const res = await sendFollow({
    to_user_id: item.user_id,
    to_org_id: item.organization_id,
    to_user_name: item.name,
    to_org_name: item.organization_name,
  })
  if (res.code !== 0) {
    return
  }

  message.success($t('shen-qing-cheng-gong'))
  hide()
  emit('success')
}

const getTeam = async () => {
  const res = await getFollwTeam()
  if (res.code !== 0) {
    return
  }

  data.value = res.data || []
}

onMounted(() => {
  getTeam()
})
</script>
